import React, { Component } from "react";

import TextField from "./form/TextField";
import TextareaField from "./form/TextareaField";
import CheckboxField from "./form/CheckboxField";
import moment from "moment";
import db from "../../api/db";
import CircularProgress from "@material-ui/core/CircularProgress";

class GroupEditCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      achievements: {
        nb: "",
        de: "",
        en: ""
      },
      tags: {
        nb: "",
        de: "",
        en: ""
      },
      bio: {
        nb: "",
        de: "",
        en: ""
      },
      achievements_nb: "",
      tags_nb: "",
      bio_nb: "",
      glory: false,
      loading: true,
      disabled: false,
      id: this.props.id,
      new: false,
      images: [],
      image_button: "Last opp bilde",
      update_local: false,
      change_glory: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getSingledoc = this.getSingledoc.bind(this);
  }

  defaultState() {
    return {
      title: "",
      achievements: {
        nb: "",
        de: "",
        en: ""
      },
      tags: {
        nb: "",
        de: "",
        en: ""
      },
      bio: {
        nb: "",
        de: "",
        en: ""
      },
      achievements_nb: "",
      tags_nb: "",
      bio_nb: "",
      glory: false,
      id: "",
      loading: false,
      new: true,
      images: [],
      image_button: "Last opp bilde",
      update_local: false,
      change_glory: false
    };
  }

  componentDidMount() {
    this._isMounted = true;
    if (this.state.id && this.state.id !== "new") {
      this.getSingledoc();
    } else if (this.state.id === "new") {
      const defaultState = this.defaultState();
      this.setState(defaultState);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentWillReceiveProps(props) {
    if (props.id === "new") {
      const defaultState = this.defaultState();
      this.setState(defaultState);
    } else if (props.id !== this.state.id) {
      this.setState({
        loading: true
      });
      this.getSingledoc(props.id);
    }
  }

  getSingledoc(id = this.state.id) {
    db.get("group", id).then(response => {
      const group = response.data;
      if (this._isMounted) {
        this.setState({
          id: id,
          new: false,
          loading: false,
          title: group.title,
          glory: group.glory,
          images: response.data.images ? response.data.images : [],
          achievements_nb: group.achievements ? group.achievements.nb : "",
          tags_nb: group.tags ? group.tags.nb : "",
          bio_nb: group.bio ? group.bio.nb : "",
          update_local: response.data.update_local
        });
      }
    });
  }

  handleChange(event, arrays) {
    let state = this.state;

    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    if (name === "glory") {
      state["change_glory"] = true;
    }

    state[name] = value;

    this.setState(state);
  }

  handleSubmit(event) {
    event.preventDefault();

    const group = {
      title: this.state.title,
      achievements: {
        nb: this.state.achievements_nb,
        en: "",
        de: ""
      },
      tags: {
        nb: this.state.tags_nb,
        en: "",
        de: ""
      },
      bio: {
        nb: this.state.bio_nb,
        en: "",
        de: ""
      },
      glory: this.state.glory,
      update_local: moment().format(),
      _change: {
        glory: this.state.change_glory
      }
    };

    if (!this.state.new && this.state.id) {
      group["id"] = this.state.id;

      this.setState({
        disabled: true
      });

      db.patch("group", group)
        .then(response => {
          this.setState({
            title: response.data.title,
            disabled: false,
            achievements_nb: response.data.achievements.nb,
            tags_nb: response.data.tags.nb,
            bio_nb: response.data.bio.nb,
            update_local: response.data.update_local
          });
        })
        .catch(err => {
          console.log(err);
        });
    } else if (this.state.new) {
      this.setState({
        loading: true
      });

      db.create("group", group)
        .then(response => {
          this.setState({
            loading: false,
            title: response.data.title,
            achievements_nb: response.data.achievements.nb,
            tags_nb: response.data.tags.nb,
            bio_nb: response.data.bio.nb,
            new: false,
            id: response.data.id,
            update_local: response.data.update_local
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  submittable() {
    let submittable = true;

    if (!this.state.title) {
      submittable = false;
    }

    return submittable;
  }

  handleAbort(event) {
    this.props.clear();
    this.setState({
      id: ""
    });
  }

  render() {
    const state = this.state;

    if (!this.state.id && !this.state.new) {
      return null;
    }

    if (this.state.loading) {
      return (
        <div className="client-card-form-holder">
          <CircularProgress size={20} />
        </div>
      );
    }

    let metadata;

    if (state.id !== "new" && state.update_local) {
      metadata = (
        <div className="cell shrink metadata">
          Oppdatert: {moment(state.update_local).format("DD.MM YYYY, HH:mm")}
        </div>
      );
    }

    return (
      <div className="client-card-form-holder">
        <form className="client-card-form" onSubmit={this.handleSubmit}>
          <div className="grid-x">
            <div className="cell auto heading">{state.title}</div>
            {metadata}
          </div>
          <fieldset disabled={this.state.disabled}>
            <div className="grid-x">
              <div className="medium-10 cell col-1">
                <div className="grid-x">
                  <div className="medium-6 cell c1">
                    <TextField
                      className="white-input"
                      name="title"
                      value={state.title}
                      label="Tittel"
                      onChange={this.handleChange}
                      required={true}
                    />
                  </div>
                </div>
              </div>
              <div className="medium-2 cell col-2">
                <CheckboxField
                  name="glory"
                  value={state.glory}
                  label="Æresgalleri"
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className="section alt-bg">
              {state.glory ? (
                <React.Fragment>
                  <TextareaField
                    className="white-input"
                    name="achievements_nb"
                    value={this.state.achievements_nb}
                    label="Utmerkelser"
                    onChange={this.handleChange}
                  />
                  <TextareaField
                    className="white-input"
                    name="bio_nb"
                    value={this.state.bio_nb}
                    label="Bio"
                    onChange={this.handleChange}
                  />
                  <TextField
                    className="white-input"
                    name="tags_nb"
                    label="Tags (ord separert med komma)"
                    value={
                      typeof this.state.tags_nb === "string"
                        ? this.state.tags_nb
                        : ""
                    }
                    onChange={this.handleChange}
                  />
                </React.Fragment>
              ) : (
                ""
              )}
            </div>
            {this.state.id && this.state.id !== "new" ? (
              <div className="medium-12 cell grid-x"></div>
            ) : (
              ""
            )}

            <div className="medium-12 cell"></div>

            <div className="footer section alt-bg">
              <input
                className="button"
                type="submit"
                disabled={!this.submittable()}
                value={this.state.disabled ? "Lagrer..." : "Lagre"}
              />
              <input
                className="button link"
                onClick={e => this.handleAbort()}
                type="button"
                value="Avbryt"
              />
            </div>
          </fieldset>
        </form>
      </div>
    );
  }
}

export default GroupEditCard;
